module.exports = __webpack_public_path__ + "static/img/4.b66683c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/4.png
// module id = Kqm+
// module chunks = 0